import React from 'react';
import { Switch, Divider, Card } from 'antd';
import style from './style.module.scss';

export interface ToggleableSectionProps {
    title: React.ReactNode;
    checked?: boolean;
    onToggleChange: (checked: boolean) => void;
    children: React.ReactNode;
    noCard?: boolean; // If true, the section will not be wrapped in a card
    className?: string;
}

export const ToggleableSection = ({
    title,
    checked = false,
    onToggleChange,
    children,
    noCard = false,
    className,
}: ToggleableSectionProps) => {
    return (
        <div
            className={`${style.toggleable_section_wrapper} ${className || ''}`}
        >
            <div className={style.header}>
                <div className="h5_bold">{title}</div>
                <Switch checked={checked} onChange={onToggleChange} />
            </div>
            {!checked && (
                <div className={style.divider_wrapper}>
                    <Divider />
                </div>
            )}
            {checked && !noCard && <Card>{children}</Card>}
            {checked && noCard && children}
        </div>
    );
};
